/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
import { REQUEST_INSPECTION_FORM } from '../mutation-types';
import requestInspectionApi from '../../services/api/requestInspection.api';
import requestInspectionService from '../../services/requestInspection.service';
import { setState } from '../mutationHelpers';
import { RequestInspectionStorePayload } from '../../models';

const namespaced = true;

const state = {
  formFields: {
    contactFirstName: '',
    contactLastName: '',
    companyName: '',
    contactPhone: '',
    contactFax: '',
    contactEmail: '',
    contactRole: [],
    projectName: '',
    qcpProjectNumber: '',
    inspectionType: [],
    requestReason: '',

  } as RequestInspectionStorePayload,

  currentPage: 1,
  submitting: false,
  submitted: false,
};

const getters = {
  formFields: storeState => storeState.formFields,
  currentPage: storeState => storeState.currentPage,
  submitting: storeState => storeState.submitting,
  submitted: storeState => storeState.submitted,
};

const mutations = {
  [REQUEST_INSPECTION_FORM.CHANGE_CURRENT_PAGE]: setState('currentPage'),
  [REQUEST_INSPECTION_FORM.TOGGLE_SUBMITTED_STATE]: setState('submitted'),
  [REQUEST_INSPECTION_FORM.TOGGLE_SUBMITTING_STATE]: setState('submitting'),

  [REQUEST_INSPECTION_FORM.FORM_FIELDS](formState, fields) {
    Object.assign(formState.formFields, fields);
  },
};

const actions = {
  goToNextPage({ commit }) {
    commit(REQUEST_INSPECTION_FORM.CHANGE_CURRENT_PAGE, state.currentPage + 1);
    window.scrollTo(0, 0);
  },

  goToPrevPage({ commit }) {
    commit(REQUEST_INSPECTION_FORM.CHANGE_CURRENT_PAGE, state.currentPage - 1);
    window.scrollTo(0, 0);
  },

  submitForm({ commit, state: actionState }) {
    return new Promise(async (resolve, reject) => {
      commit(REQUEST_INSPECTION_FORM.TOGGLE_SUBMITTING_STATE, true);
      const createPayload = requestInspectionService.buildCreatePayload(actionState.formFields);
      try {
        await requestInspectionApi.create(createPayload);
        commit(REQUEST_INSPECTION_FORM.TOGGLE_SUBMITTED_STATE, true);
        try {
          // eslint-disable-next-line @typescript-eslint/no-angle-bracket-type-assertion
          (<any>window).gtag('config', 'UA-69171335-1', {
            page_title: 'Request Inspection - Submitted',
            page_path: '/forms/request-inspection/submitted',
          });
        } catch (error) {}
        resolve();
      } catch (error) {
        commit(REQUEST_INSPECTION_FORM.TOGGLE_SUBMITTING_STATE, false);
        reject(error);
      }
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};